import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { ScheduleHoursJornadaDTO, ServiceStatisticsHourlyDTO } from '../../dto/ServiceStatisticsDTO';
import HourlyChart from './HourlyChart';
import { realRange, scheduledRange } from './periodDetail';
import { buildHourlyTotal, Measure } from './statisticsUtils';

interface PeriodDetailHoursProps {
    /** Un día: la curva por hora. */
    hourly: ServiceStatisticsHourlyDTO | null;
    /** Un día de una agenda de consultorio elegida: lo programado y lo real. */
    jornada: ScheduleHoursJornadaDTO | null;
    measure: Measure;
}

/** «A qué hora»: una sola línea con todo lo del día y, con una agenda elegida, el horario programado y el real (solo texto). */
export default function PeriodDetailHours({ hourly, jornada, measure }: PeriodDetailHoursProps) {
    const intl = useIntl();
    const points = useMemo(() => (hourly ? buildHourlyTotal(hourly) : null), [hourly]);

    if (!points || points.every(point => point.attentions === 0)) {
        return <p className="nv-muted">{intl.formatMessage({ id: 'ServicesStatisticsPeriodDetailHoursEmpty' })}</p>;
    }
    return (
        <>
            <HourlyChart points={points} measure={measure}
                ariaLabel={intl.formatMessage({ id: 'ServicesStatisticsPeriodDetailHoursAria' })} />
            {jornada && (
                <p className="nv-help">
                    {intl.formatMessage({ id: 'ServicesStatisticsPeriodDetailSchedule' }, {
                        scheduled: scheduledRange(jornada.scheduledFrom, jornada.scheduledTo),
                        real: realRange(jornada.firstServed, jornada.lastCompleted),
                    })}
                </p>
            )}
        </>
    );
}
